<template>
  <span class="pz-logo text">
    <span>Ping</span><span>Zapper</span>
  </span>
</template>
